import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-check-circle-fill",
  templateUrl: "./med-icon-check-circle-fill.component.html",
})
export class MedIconCheckCircleFillComponent extends SvgMixinComponent {}
